import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import SwaggerContext from "../SwaggerContext";
import { notifyError } from "../actions/notifications";
import { createApiCallback } from "../utils/error-handler";

const FilterModal = ({
  showModal,
  setShowModal,
  filterType,
  setFilter,
  loadCategories,
  filter,
}) => {
  const [filterValue, setFilterValue] = useState("");
  const [data, setData] = useState([]); // Estado para las categorías
  const { categoryApi } = useContext(SwaggerContext);

  // Sincronizar filterValue con el filtro actual cuando se abre el modal
  useEffect(() => {
    if (showModal && filterType && filter[filterType] !== undefined) {
      setFilterValue(filter[filterType] ?? "");
    }
  }, [showModal, filterType, filter]);

  useEffect(() => {
    if (loadCategories) {
      const opts = {
        page: 0,
        limit: 100,
      }; // Opciones de consulta si son necesarias
      categoryApi.getCategories(opts, createApiCallback(
        (data) => {
          setData(data); // Actualiza las categorías
        },
        (errorMessage) => {
          notifyError(`Ha habido un error al cargar la lista de categorías: ${errorMessage}`);
        }
      ));
    }
  }, [loadCategories, categoryApi]);

  const handleChangeValue = (e) => {
    let value = e.target.value;
    setFilterValue(value);
  };

  const applyFilter = () => {
    setShowModal(false);
    // Asegúrate de que filterType sea válido antes de actualizar el estado
    if (filterType) {
      setFilter((prevFilter) => ({
        ...prevFilter,
        [filterType]: filterValue === "" ? null : filterValue,
      }));
    }
  };

  const renderFilterControl = () => {
  if (filterType === "enabled") {
    return (
      <Form.Select
        value={filterValue ?? ""}
        onChange={handleChangeValue}
      >
        <option value="">Selecciona</option>
        <option value="true">Activa</option>
        <option value="false">Inactiva</option>
      </Form.Select>
    );
  }

  if (filterType === "type") {
    return (
      <Form.Select value={filterValue ?? ""} onChange={handleChangeValue}>
        <option>Establecer tipo</option>
        <option value="CAUSA_EMOCION">Causa emoción</option>
        <option value="DESEO_EMOCION">Deseo emoción</option>
        <option value="EMOCION_COMPLEJA">Emoción compleja</option>
        <option value="PENSAMIENTO_EMOCION">Pensamiento emoción</option>
        <option value="INTERACCION">Interacción</option>
        <option value="EMOCION_GRUPO">Emoción grupo</option>
      </Form.Select>
    );
  }

  if (loadCategories && data?.categories) {
    return (
      <Form.Select value={filterValue ?? ""} onChange={handleChangeValue}>
        <option value="">Selecciona una categoría</option>
        {data.categories.map((category) => (
          <option key={category.id} value={category.id}>
            {category.name}
          </option>
        ))}
      </Form.Select>
    );
  }

  return (
    <Form.Control
      type="text"
      placeholder="Filtro"
      value={filterValue ?? ""}
      onChange={handleChangeValue}
    />
  );
};


  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      dialogClassName="modal-50w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
      <Form.Group controlId="filter">
        {renderFilterControl()}
      </Form.Group>
        <ul>
          <li>Tipo: {filter.type}</li>
          <li>
            Categoría:{" "}
            {data.categories &&
              filter.categoryId &&
              (() => {
                const category = data.categories.find(
                  (category) => {
                    return category.id === parseInt(filter.categoryId)}
                );
                return category ? category.name : "No encontrada";
              })()}
          </li>
          <li>Título: {filter.title}</li>
          <li>Estado: {filter.enabled ? "Activa" : filter.enabled != null ? "Inactiva" : ""}</li>
        </ul>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center">
        <Button
          className="mx-2"
          variant="success"
          onClick={applyFilter} // Aplica el filtro al pulsar "Aceptar"
        >
          Aceptar
        </Button>
        <Button
          variant="warning"
          onClick={() => {
            setShowModal(false);
            setFilter({ type: null, title: null, categoryId: null, enabled: null }); // Limpia los filtros
            setFilterValue("");
          }}
        >
          Limpiar filtros
        </Button>
        &nbsp;&nbsp;
        <Button variant="danger" onClick={() => setShowModal(false)}>
          Cancelar
        </Button>
      </Modal.Body>
    </Modal>
  );
};

FilterModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  filterType: PropTypes.string,
  setFilter: PropTypes.func,
  loadCategories: PropTypes.bool,
  filter: PropTypes.object,
};

export default FilterModal;
